import React, { useEffect, useState } from 'react';
import { CurrencyField, DataTable, Field } from '../../commons/DataTable';
import { useTranslation } from 'react-i18next';
import ReportingTypeField from '../../commons/DataTable/ReportingTypeField';
import SignalmanField from '../../commons/DataTable/SignalmanField';

function SignalsTabel({ data, total = 0 }) {
  const [t] = useTranslation('COMMON');

  const [signals, setSignals] = useState(data || []);
  const [query, setQuery] = useState({
    limit: 50,
    offset: 0,
  });

  const { limit, offset } = query;

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  useEffect(() => {
    const paginatedSignals = signals.slice(offset, offset + limit);
    setSignals(paginatedSignals);
  }, [offset, limit]);

  return (
    <DataTable
      data={signals}
      total={data.length}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('NO_DATA')}
    >
      <Field
        title="Tipo segnalazione"
        source="signalTypeInfo.name"
        className="text-left"
      />
      <SignalmanField
        title="Ruolo"
        source="signalmanPosition"
        className="text-left"
      />
      <Field
        title="Segnalatore"
        source="signalman.businessName"
        className="text-left"
      />
      <Field
        title="Segnalatore P.iva/Codice Fiscale"
        source="signalman.fiscalCode"
        className="text-left"
      />
      <Field
        title="Note"
        source="notes"
        className="text-left"
        style={{
          maxWidth: '300px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
        }}
      />
      <CurrencyField
        title="Quota Da Dare"
        source="adminShare"
        className="txt-table-right"
      />
    </DataTable>
  );
}

export default SignalsTabel;
